import React from "react";
import { observer, inject } from "mobx-react";
import "./ObSurveilPatient.scss";
import ObSurveilPatientStore from "./ObSurveilPatientStore";
import className from "../../../shared/className";
import Loader from "../../../shared/Loader";
import _ from "lodash";
import DilatationMeter from "./DilatationMeter";
import ObPatientInfo from "./ObPatientInfo";
import ObSurveilPatientPanel from "./ObSurveilPatientPanel";
import {
  OB_SUMMARY_TILE_ORDER,
  OB_SUMMARY_TILE_LABELS,
} from "../../ObSummary/ObSummaryConstants";
import ResponsiveComponent from "../../../shared/ResponsiveComponent.js";

class ObSurveilPatient extends React.Component {
  constructor(props) {
    super(props);
    this.store = new ObSurveilPatientStore(props);
    this.store.fetchObSummary({ asmpid: this.props.patient.asmpid });
    this.renderPanels = this.renderPanels.bind(this);
    this._ref = React.createRef();
  }

  componentWillUnmount() {
    this.store.dispose();
  }

  renderPanels() {
    return OB_SUMMARY_TILE_ORDER.map((key) =>
      this.store.tiles[key] ? (
        <div
          key={key}
          {...className({
            option: true,
            selected: this.store.selectedPanel === key,
          })}
          onClick={(e) => this.selectPanel(e, key)}
        >
          {OB_SUMMARY_TILE_LABELS[key]}
        </div>
      ) : null,
    );
  }

  render() {
    return (
      <ResponsiveComponent
        blockSizes={{ short: 280, "mid-height": 370 }}
        inlineSizes={{ thick: 400, wide: 500 }}
      >
        <div
          {...className({
            "ob-surveil-patient component": 1,
            selected: this.props.selected,
          })}
          onClick={this.props.onClick || _.noop}
          ref={this._ref}
        >
          <header>
            <DilatationMeter
              dilatation={this.props.moduleSpecifics.dilatation}
            />
            <ObPatientInfo
              showPHI={this.props.obSurveilStore.showPHI}
              patient={this.props.patient}
              specifics={this.props.moduleSpecifics}
            ></ObPatientInfo>
          </header>
          <div className="main">
            {this.store.loading ? (
              <Loader />
            ) : (
              <ObSurveilPatientPanel
                store={this.store}
                selectedPatient={this.props.selectedPatient}
              />
            )}
          </div>
          <div className="selector">{this.renderPanels()}</div>
        </div>
      </ResponsiveComponent>
    );
  }

  selectPanel(e, panel) {
    e && e.stopPropagation();
    this.store.selectedPanel =
      this.store.selectedPanel === panel ? null : panel;
  }
}

export default inject("store")(observer(ObSurveilPatient));
